import { useFormik } from 'formik';
import * as Yup from 'yup';

import {useAuth} from "src/contexts/auth";

export const useFormLogin = () => {
    const { signIn } = useAuth();

    const validationSchema = Yup.object().shape({
        email: Yup.string().email('E-mail inválido!').required('Campo obrigatório!'),
        password: Yup.string().required('Campo obrigatório!'),
    });

    const formik = useFormik({
        initialValues: {
            email: '', 
            password: ''
        },
        onSubmit: values => {
            signIn({
                email: values.email, 
                password:values.password
            });
        },
        validationSchema
    });

    return formik;
};  